// import { useLayout } from "../layout/core";
// import { ThemeModeComponent } from "../assets/ts/layout";

import { ThemeModeComponent } from "../assets/ts/layout";
import { useLayout } from "../layout/core";

/**
 * Görsel yollarını site kökünden çözer.
 *
 * Önceden "./" ile göreli üretiliyordu; alt yollu bir ekranda (ör. /jobqueue/list) sayfa
 * yenilendiğinde tarayıcı görseli o yolun altında arıyordu (/jobqueue/media/...) ve bulamıyordu.
 * Oturum düşüp giriş ekranı böyle bir adreste açıldığında logo kırık görünüyordu.
 *
 * Uygulama site kökünden yayınlandığı için (index.html kendi dosyalarını /static/... diye
 * çağırıyor) yol da kökten verilir. Başında bölü olan çağrılar da doğru çalışsın diye
 * fazladan bölü işaretleri temizlenir.
 */
export const toAbsoluteUrl = (pathname: string) =>
    "/" + (pathname ?? "").replace(/^\/+/, "");

export const useIllustrationsPath = (illustrationName: string): string => {
    const { config } = useLayout();

    const extension = illustrationName.substring(
        illustrationName.lastIndexOf("."),
        illustrationName.length
    );
    const illustration =
        ThemeModeComponent.getMode() === "dark"
            ? `${illustrationName.substring(
                0,
                illustrationName.lastIndexOf(".")
            )}-dark`
            : illustrationName.substring(0, illustrationName.lastIndexOf("."));
    return toAbsoluteUrl(
        `media/illustrations/${config.illustrations?.set}/${illustration}${extension}`
    );
};
